var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"image",attrs:{"src":`${_vm.url}&w=730`,"alt":_vm.image.alt ? _vm.image.alt : '',"srcset":`
      ${_vm.url}&w=730 1x,
      ${_vm.url}&w=1460 2x,
      ${_vm.url}&w=2190 3x
    `}}),(_vm.url || _vm.image.alt)?_c('div',{staticClass:"text"},[(_vm.image.alt)?_c('span',[_vm._v(_vm._s(_vm.image.alt))]):_vm._e(),(_vm.image.copyright)?_c('span',[_vm._v(_vm._s(_vm.image.copyright))]):_vm._e()]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }